import { render, staticRenderFns } from "./NewServiceRequest.vue?vue&type=template&id=590f0c66&scoped=true"
import script from "./NewServiceRequest.vue?vue&type=script&lang=js"
export * from "./NewServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f0c66",
  null
  
)

export default component.exports